import React, { useEffect, useRef, useState } from "react";
import {
  Button,
  Form,
  Col,
  Row,
  Tabs,
  Tab,
  ButtonGroup,
  DropdownButton,
  Dropdown,
} from "react-bootstrap";
import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderTitle,
  CardHeaderToolbar,
} from "../../../_metronic/_partials/controls";
import Select from "react-select";

import { useSelector, useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import {
  resetData,
  selectData,
  selectLoading,
  selectPageNo,
  selectPageSize,
  selectTotalRecord,
  fetchData,
  fetchIdSummary,
  fetchId,
  selectId,
} from "./resultSlice";
import { LayoutSplashScreen } from "../../../_metronic/layout";
import {
  CallApi,
  createChangeHandler,
  formatDate,
  formatDateTime,
  getValueStatus,
  handleSetOptionsMaster,
  paramsMasterAll,
  setOptionsMaster2,
  showErrorDialog,
} from "../../utility";
import { ResultTable } from "./ResultTable";
import { fetchParam2, selectDataParam2 } from "../param/paramSlice";
import { InputDateRange } from "../../utility/InputDateRange";
import { fetchUser, selectDataUser } from "../user/userSlice";
import { ModalSummary } from "./ModalSummary";
import { SummaryCard } from "./SummaryCard";
import { ResultIndividual } from "./ResultIndividual";

export const ResultPage = (params) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const data = useSelector(selectData);
  const loading = useSelector(selectLoading);
  const pageNo = useSelector(selectPageNo);
  const pageSize = useSelector(selectPageSize);
  const totalRecord = useSelector(selectTotalRecord);
  const dataParam2 = useSelector(selectDataParam2);
  const dataUser = useSelector(selectDataUser);
  const dataId = useSelector(selectId);

  const dataState = params.location.state;

  // Filter
  const [name, setName] = useState("");
  const [customer, setCustomer] = useState("");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [sales, setSales] = useState("");
  const [dataSummary, setDataSummary] = useState(null);

  const [optionsCategory, setOptionsCategory] = useState([]);
  const [optionsSales, setOptionSales] = useState([]);
  const containerRef = useRef(null);

  useEffect(() => {
    // Fokus otomatis saat komponen di-render
    if (containerRef.current) {
      containerRef.current.focus();
    }
  }, []);

  useEffect(() => {
    async function fetchMyAPI() {
      await dispatch(resetData());
      await handleGetSummary();
      await dispatch(
        fetchData({
          survey_id: dataState?.survey_id,
          pageNo: 1,
          pageSize: -1,
        })
      );
      await dispatch(
        fetchUser({
          ...paramsMasterAll,
          roles_in: "COMPANY_SALES,COMPANY_SUPERVISOR",
          is_active: true,
        })
      );
    }
    fetchMyAPI();
  }, [dispatch]);

  useEffect(() => {
    handleSetOptionsMaster(
      dataParam2,
      setOptionsCategory,
      "param_code",
      "param_value"
    );
  }, [dataParam2]);

  useEffect(() => {
    if (dataUser.length > 0) {
      setOptionsMaster2(dataUser, setOptionSales, "username", [
        "username",
        "name",
      ]);
    }
  }, [dataUser]);

  const handleChangeSales = createChangeHandler(setSales);
  const [show, setShow] = useState(false);

  const handleGetSummary = async () => {
    try {
      const response = await dispatch(
        fetchIdSummary({ survey_id: dataState?.survey_id })
      );
      if (response.payload.data.status_code === 200) {
        setDataSummary(response.payload.data.data);
      } else {
        showErrorDialog(response.payload.data.message);
      }
    } catch (error) {
      showErrorDialog(error.message);
    }
  };

  const handleClose = () => {
    setDataSummary(null);
    setShow(false);
  };
  const [activeTab, setActiveTab] = useState("Summary");

  const handleTabClick = (tab) => {
    setActiveTab(tab);
  };

  const [currentPage, setCurrentPage] = useState(1);
  const [currentPageName, setCurrentPageName] = useState("");
  const totalPages = data?.length;

  useEffect(() => {
    if (data.length > 0) {
      setCurrentPageName(
        data?.[0]?.customer_store_name + "-" + data?.[0]?.created_by || ""
      );
      CallApi(
        {
          survey_result_id: data[0].survey_result_id,
        },
        fetchId,
        dispatch
      );
    }
  }, [data]);

  console.log(dataId, "dataId");

  const handlePrevious = () => {
    if (currentPage > 1) {
      const newPage = currentPage - 1;
      setCurrentPage(newPage);

      setCurrentPageName(
        data[newPage - 1].customer_store_name +
          "-" +
          data[newPage - 1].created_by
      );

      CallApi(
        {
          survey_result_id: data[newPage - 1].survey_result_id,
        },
        fetchId,
        dispatch
      );
    }
  };

  const handleNext = () => {
    if (currentPage < totalPages) {
      const newPage = currentPage + 1;
      setCurrentPage(newPage);
      setCurrentPageName(
        data[newPage - 1].customer_store_name +
          "-" +
          data[newPage - 1].created_by
      );

      CallApi(
        {
          survey_result_id: data[newPage - 1].survey_result_id,
        },
        fetchId,
        dispatch
      );
    }
  };

  useEffect(() => {
    const handleKeyPress = (event) => {
      console.log(event.key, "Key Pressed");
      if (event.key === "ArrowLeft" && currentPage > 1) {
        handlePrevious();
      }
      if (event.key === "ArrowRight" && currentPage < totalPages) {
        handleNext();
      }
    };

    // Menambahkan event listener ke window
    window.addEventListener("keydown", handleKeyPress);

    // Membersihkan event listener saat komponen di-unmount
    return () => {
      window.removeEventListener("keydown", handleKeyPress);
    };
  }, [handlePrevious, handleNext, currentPage, totalPages]);

  const handleKeyPress = (event) => {
    if (event.key === "ArrowLeft" && currentPage > 1) {
      handlePrevious();
    }
    if (event.key === "ArrowRight" && currentPage < totalPages) {
      handleNext();
    }
  };

  return loading ? (
    <LayoutSplashScreen />
  ) : (
    <>
      <Card>
        <CardHeader>
          <CardHeaderTitle className="card-title">
            Result Survey : {dataState?.survey_title}
          </CardHeaderTitle>
        </CardHeader>
        <CardBody>
          <div style={{ width: "100%", textAlign: "center" }}>
            {/* Tab Header */}
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                borderBottom: "2px solid #ccc",
              }}
            >
              {["Summary", , "Individual"].map((tab) => (
                <button
                  key={tab}
                  onClick={() => handleTabClick(tab)}
                  style={{
                    padding: "10px 20px",
                    margin: "0 5px",
                    border: "none",
                    borderBottom:
                      activeTab === tab ? "3px solid #673AB7" : "none",
                    background: "none",
                    fontWeight: activeTab === tab ? "bold" : "normal",
                    color: activeTab === tab ? "#673AB7" : "#333",
                    cursor: "pointer",
                  }}
                >
                  {tab}
                </button>
              ))}
            </div>
          </div>
        </CardBody>
      </Card>

      {/* Tab Content */}
      <div style={{ padding: "20px", textAlign: "left" }}>
        {activeTab === "Summary" && (
          <div>
            <div
              style={{
                padding: "20px",
                border: "1px solid #ddd",
                borderRadius: "8px",
                backgroundColor: "#f9f9f9",
                marginBottom: "40px",
              }}
            >
              <h5>Who answered?</h5>
              <hr />

              <ul
                style={{
                  listStyleType: "none",
                  padding: "0",
                  maxHeight: "200px",
                  overflowY: "auto",
                  margin: "0",
                }}
              >
                {data.map((answer, idx) => (
                  <li
                    key={idx}
                    style={{
                      padding: "10px",
                      borderBottom: "1px solid #ddd",
                      cursor: "pointer", // Menunjukkan bahwa elemen dapat diklik
                      color: "blue", // Memberikan warna biru pada teks
                      textDecoration: "underline", // Memberikan underline agar terlihat seperti link
                    }}
                    onClick={() => {
                      setActiveTab("Individual"); // Set tab ke "Individual"
                      setCurrentPage(idx + 1);

                      setCurrentPageName(answer.customer_store_name);
                      CallApi(
                        {
                          survey_result_id: answer.survey_result_id, // Mengambil ID hasil survei
                        },
                        fetchId,
                        dispatch
                      ); // Memanggil API dengan parameter
                    }}
                  > {idx+1}. 
                    {answer.customer_code} ({answer.customer_store_name}) -{" "}
                    {answer.surveyor_name}
                  </li>
                ))}
              </ul>
            </div>

            <SummaryCard data={dataSummary} />
          </div>
        )}

        {activeTab === "Individual" && (
          <>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                padding: "10px",
                border: "1px solid #ddd",
                borderRadius: "8px",
                backgroundColor: "#f9f9f9",
              }}
            >
              {/* Dropdown */}
              <DropdownButton
                as={ButtonGroup}
                title={`Jawaban ${currentPageName}`}
                id="dropdown-basic"
                variant="outline-secondary"
                style={{ width: "250px" }} // Menetapkan lebar tetap pada DropdownButton
              >
                {data.map((item, index) => (
                  <Dropdown.Item
                    key={item.index}
                    onClick={() => {
                      setCurrentPage(index + 1);

                      setCurrentPageName(
                        item.customer_store_name + "-" + item.created_by
                      );

                      CallApi(
                        {
                          survey_result_id: data[index].survey_result_id,
                        },
                        fetchId,
                        dispatch
                      );
                    }}
                  >
                    {item.customer_store_name} - {item.created_by}
                  </Dropdown.Item>
                ))}
              </DropdownButton>

              <div className="mt-3">
                <p> Submit Date : {formatDateTime(dataId?.created_at)}</p>
              </div>

              {/* Pagination */}
              <div
                ref={containerRef}
                style={{ display: "flex", alignItems: "center" }}
                tabIndex={0} // Agar div bisa menerima fokus
                onKeyDown={handleKeyPress} // Letakkan di div
                onFocus={(e) => e.target.focus()} // Tambahkan agar fokus otomatis
              >
                <button
                  className="btn btn-outline-secondary"
                  onClick={handlePrevious}
                  disabled={currentPage === 1}
                >
                  &lt;
                </button>
                <span style={{ margin: "0 10px" }}>
                  {currentPage} dari {totalPages}
                </span>
                <button
                  className="btn btn-outline-secondary"
                  onClick={handleNext}
                  disabled={currentPage === totalPages}
                >
                  &gt;
                </button>
              </div>
            </div>

            <div className="mt-5">
              <ResultIndividual />
            </div>
          </>
        )}
      </div>
    </>
  );
};
